export { AmplitudeCreator } from './amplitude.creator';
export { AMPLITUDE_DEFAULTS, AMPLITUDE_DEFAULT_PARAMS, type AmplitudeParams } from './amplitude.model';
